/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var aa = require("react");

function l(a) {
  for (var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++) {
    b += "&args[]=" + encodeURIComponent(arguments[c]);
  }

  return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}

var p = Object.prototype.hasOwnProperty,
    fa = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
    ha = {},
    ia = {};

function ja(a) {
  if (p.call(ia, a)) return !0;
  if (p.call(ha, a)) return !1;
  if (fa.test(a)) return ia[a] = !0;
  ha[a] = !0;
  return !1;
}

function r(a, b, c, d, f, e, g) {
  this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
  this.attributeName = d;
  this.attributeNamespace = f;
  this.mustUseProperty = c;
  this.propertyName = a;
  this.type = b;
  this.sanitizeURL = e;
  this.removeEmptyString = g;
}

var t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (a) {
  t[a] = new r(a, 0, !1, a, null, !1, !1);
});
[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (a) {
  var b = a[0];
  t[b] = new r(b, 1, !1, a[1], null, !1, !1);
});
["contentEditable", "draggable", "spellCheck", "value"].forEach(function (a) {
  t[a] = new r(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (a) {
  t[a] = new r(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (a) {
  t[a] = new r(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
["checked", "multiple", "muted", "selected"].forEach(function (a) {
  t[a] = new r(a, 3, !0, a, null, !1, !1);
});
["capture", "download"].forEach(function (a) {
  t[a] = new r(a, 4, !1, a, null, !1, !1);
});
["cols", "rows", "size", "span"].forEach(function (a) {
  t[a] = new r(a, 6, !1, a, null, !1, !1);
});
["rowSpan", "start"].forEach(function (a) {
  t[a] = new r(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var ka = /[\-:]([a-z])/g;

function la(a) {
  return a[1].toUpperCase();
}

"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (a) {
  var b = a.replace(ka, la);
  t[b] = new r(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (a) {
  var b = a.replace(ka, la);
  t[b] = new r(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
["xml:base", "xml:lang", "xml:space"].forEach(function (a) {
  var b = a.replace(ka, la);
  t[b] = new r(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
["tabIndex", "crossOrigin"].forEach(function (a) {
  t[a] = new r(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
t.xlinkHref = new r("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
["src", "href", "action", "formAction"].forEach(function (a) {
  t[a] = new r(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var u = {
  animationIterationCount: !0,
  aspectRatio: !0,
  borderImageOutset: !0,
  borderImageSlice: !0,
  borderImageWidth: !0,
  boxFlex: !0,
  boxFlexGroup: !0,
  boxOrdinalGroup: !0,
  columnCount: !0,
  columns: !0,
  flex: !0,
  flexGrow: !0,
  flexPositive: !0,
  flexShrink: !0,
  flexNegative: !0,
  flexOrder: !0,
  gridArea: !0,
  gridRow: !0,
  gridRowEnd: !0,
  gridRowSpan: !0,
  gridRowStart: !0,
  gridColumn: !0,
  gridColumnEnd: !0,
  gridColumnSpan: !0,
  gridColumnStart: !0,
  fontWeight: !0,
  lineClamp: !0,
  lineHeight: !0,
  opacity: !0,
  order: !0,
  orphans: !0,
  tabSize: !0,
  widows: !0,
  zIndex: !0,
  zoom: !0,
  fillOpacity: !0,
  floodOpacity: !0,
  stopOpacity: !0,
  strokeDasharray: !0,
  strokeDashoffset: !0,
  strokeMiterlimit: !0,
  strokeOpacity: !0,
  strokeWidth: !0
},
    ma = ["Webkit", "ms", "Moz", "O"];
Object.keys(u).forEach(function (a) {
  ma.forEach(function (b) {
    b = b + a.charAt(0).toUpperCase() + a.substring(1);
    u[b] = u[a];
  });
});
var na = /["'&<>]/;

function v(a) {
  if ("boolean" === typeof a || "number" === typeof a) return "" + a;
  a = "" + a;
  var b = na.exec(a);

  if (b) {
    var c = "",
        d,
        f = 0;

    for (d = b.index; d < a.length; d++) {
      switch (a.charCodeAt(d)) {
        case 34:
          b = "&quot;";
          break;

        case 38:
          b = "&amp;";
          break;

        case 39:
          b = "&#x27;";
          break;

        case 60:
          b = "&lt;";
          break;

        case 62:
          b = "&gt;";
          break;

        default:
          continue;
      }

      f !== d && (c += a.substring(f, d));
      f = d + 1;
      c += b;
    }

    a = f !== d ? c + a.substring(f, d) : c;
  }

  return a;
}

var oa = /([A-Z])/g,
    pa = /^ms-/,
    qa = Array.isArray;

function w(a, b) {
  return {
    insertionMode: a,
    selectedValue: b
  };
}

function ra(a, b, c) {
  switch (b) {
    case "select":
      return w(1, null != c.value ? c.value : c.defaultValue);

    case "svg":
      return w(2, null);

    case "math":
      return w(3, null);

    case "foreignObject":
      return w(1, null);

    case "table":
      return w(4, null);

    case "thead":
    case "tbody":
    case "tfoot":
      return w(5, null);

    case "colgroup":
      return w(7, null);

    case "tr":
      return w(6, null);
  }

  return 4 <= a.insertionMode || 0 === a.insertionMode ? w(1, null) : a;
}

var sa = new Map();

function ta(a, b, c) {
  if ("object" !== _typeof(c)) throw Error(l(62));
  b = !0;

  for (var d in c) {
    if (p.call(c, d)) {
      var f = c[d];

      if (null != f && "boolean" !== typeof f && "" !== f) {
        if (0 === d.indexOf("--")) {
          var e = v(d);
          f = v(("" + f).trim());
        } else {
          e = d;
          var g = sa.get(e);
          void 0 !== g ? e = g : (g = v(e.replace(oa, "-$1").toLowerCase().replace(pa, "-ms-")), sa.set(e, g), e = g);
          f = "number" === typeof f ? 0 === f || p.call(u, d) ? "" + f : f + "px" : v(("" + f).trim());
        }

        b ? (b = !1, a.push(' style="', e, ":", f)) : a.push(";", e, ":", f);
      }
    }
  }

  b || a.push('"');
}

function x(a, b, c, d) {
  switch (c) {
    case "style":
      ta(a, b, d);
      return;

    case "defaultValue":
    case "defaultChecked":
    case "innerHTML":
    case "suppressContentEditableWarning":
    case "suppressHydrationWarning":
      return;
  }

  if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) if (b = t.hasOwnProperty(c) ? t[c] : null, null !== b) {
    switch (_typeof(d)) {
      case "function":
      case "symbol":
        return;

      case "boolean":
        if (!b.acceptsBooleans) return;
    }

    c = b.attributeName;

    switch (b.type) {
      case 3:
        d && a.push(" ", c, '=""');
        break;

      case 4:
        !0 === d ? a.push(" ", c, '=""') : !1 !== d && a.push(" ", c, '="', v(d), '"');
        break;

      case 5:
        isNaN(d) || a.push(" ", c, '="', v(d), '"');
        break;

      case 6:
        !isNaN(d) && 1 <= d && a.push(" ", c, '="', v(d), '"');
        break;

      default:
        b.sanitizeURL && (d = "" + d), a.push(" ", c, '="', v(d), '"');
    }
  } else if (ja(c)) {
    switch (_typeof(d)) {
      case "function":
      case "symbol":
        return;

      case "boolean":
        if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
    }

    a.push(" ", c, '="', v(d), '"');
  }
}

function y(a, b, c) {
  if (null != b) {
    if (null != c) throw Error(l(60));
    if ("object" !== _typeof(b) || !("__html" in b)) throw Error(l(61));
    b = b.__html;
    null !== b && void 0 !== b && a.push("" + b);
  }
}

function ua(a) {
  var b = "";
  aa.Children.forEach(a, function (a) {
    null != a && (b += a);
  });
  return b;
}

function va(a, b, c, d) {
  a.push(A(c));
  var f = c = null,
      e;

  for (e in b) {
    if (p.call(b, e)) {
      var g = b[e];
      if (null != g) switch (e) {
        case "children":
          c = g;
          break;

        case "dangerouslySetInnerHTML":
          f = g;
          break;

        default:
          x(a, d, e, g);
      }
    }
  }

  a.push(">");
  y(a, f, c);
  return "string" === typeof c ? (a.push(v(c)), null) : c;
}

var wa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,
    xa = new Map();

function A(a) {
  var b = xa.get(a);

  if (void 0 === b) {
    if (!wa.test(a)) throw Error(l(65, a));
    b = "<" + a;
    xa.set(a, b);
  }

  return b;
}

function ya(a, b, c, d, f) {
  switch (b) {
    case "select":
      a.push(A("select"));
      var e = null,
          g = null;

      for (n in c) {
        if (p.call(c, n)) {
          var h = c[n];
          if (null != h) switch (n) {
            case "children":
              e = h;
              break;

            case "dangerouslySetInnerHTML":
              g = h;
              break;

            case "defaultValue":
            case "value":
              break;

            default:
              x(a, d, n, h);
          }
        }
      }

      a.push(">");
      y(a, g, e);
      return e;

    case "option":
      g = f.selectedValue;
      a.push(A("option"));
      var k = h = null,
          m = null;
      var n = null;

      for (e in c) {
        if (p.call(c, e)) {
          var q = c[e];
          if (null != q) switch (e) {
            case "children":
              h = q;
              break;

            case "selected":
              m = q;
              break;

            case "dangerouslySetInnerHTML":
              n = q;
              break;

            case "value":
              k = q;

            default:
              x(a, d, e, q);
          }
        }
      }

      if (null != g) {
        if (c = null !== k ? "" + k : ua(h), qa(g)) for (d = 0; d < g.length; d++) {
          if ("" + g[d] === c) {
            a.push(' selected=""');
            break;
          }
        } else "" + g === c && a.push(' selected=""');
      } else m && a.push(' selected=""');
      a.push(">");
      y(a, n, h);
      return h;

    case "textarea":
      a.push(A("textarea"));
      n = g = e = null;

      for (h in c) {
        if (p.call(c, h) && (k = c[h], null != k)) switch (h) {
          case "children":
            n = k;
            break;

          case "value":
            e = k;
            break;

          case "defaultValue":
            g = k;
            break;

          case "dangerouslySetInnerHTML":
            throw Error(l(91));

          default:
            x(a, d, h, k);
        }
      }

      null === e && null !== g && (e = g);
      a.push(">");

      if (null != n) {
        if (null != e) throw Error(l(92));
        if (qa(n) && 1 < n.length) throw Error(l(93));
        e = "" + n;
      }

      "string" === typeof e && "\n" === e[0] && a.push("\n");
      null !== e && a.push(v("" + e));
      return null;

    case "input":
      a.push(A("input"));
      k = n = h = e = null;

      for (g in c) {
        if (p.call(c, g) && (m = c[g], null != m)) switch (g) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(l(399, "input"));

          case "defaultChecked":
            k = m;
            break;

          case "defaultValue":
            h = m;
            break;

          case "checked":
            n = m;
            break;

          case "value":
            e = m;
            break;

          default:
            x(a, d, g, m);
        }
      }

      null !== n ? x(a, d, "checked", n) : null !== k && x(a, d, "checked", k);
      null !== e ? x(a, d, "value", e) : null !== h && x(a, d, "value", h);
      a.push("/>");
      return null;

    case "menuitem":
      a.push(A("menuitem"));

      for (var C in c) {
        if (p.call(c, C) && (e = c[C], null != e)) switch (C) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(l(400));

          default:
            x(a, d, C, e);
        }
      }

      a.push(">");
      return null;

    case "title":
      a.push(A("title"));
      e = null;

      for (q in c) {
        if (p.call(c, q) && (g = c[q], null != g)) switch (q) {
          case "children":
            e = g;
            break;

          case "dangerouslySetInnerHTML":
            throw Error(l(434));

          default:
            x(a, d, q, g);
        }
      }

      a.push(">");
      return e;

    case "listing":
    case "pre":
      a.push(A(b));
      g = e = null;

      for (k in c) {
        if (p.call(c, k) && (h = c[k], null != h)) switch (k) {
          case "children":
            e = h;
            break;

          case "dangerouslySetInnerHTML":
            g = h;
            break;

          default:
            x(a, d, k, h);
        }
      }

      a.push(">");

      if (null != g) {
        if (null != e) throw Error(l(60));
        if ("object" !== _typeof(g) || !("__html" in g)) throw Error(l(61));
        c = g.__html;
        null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push("\n", c) : a.push("" + c));
      }

      "string" === typeof e && "\n" === e[0] && a.push("\n");
      return e;

    case "area":
    case "base":
    case "br":
    case "col":
    case "embed":
    case "hr":
    case "img":
    case "keygen":
    case "link":
    case "meta":
    case "param":
    case "source":
    case "track":
    case "wbr":
      a.push(A(b));

      for (var D in c) {
        if (p.call(c, D) && (e = c[D], null != e)) switch (D) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(l(399, b));

          default:
            x(a, d, D, e);
        }
      }

      a.push("/>");
      return null;

    case "annotation-xml":
    case "color-profile":
    case "font-face":
    case "font-face-src":
    case "font-face-uri":
    case "font-face-format":
    case "font-face-name":
    case "missing-glyph":
      return va(a, c, b, d);

    case "html":
      return 0 === f.insertionMode && a.push("<!DOCTYPE html>"), va(a, c, b, d);

    default:
      if (-1 === b.indexOf("-") && "string" !== typeof c.is) return va(a, c, b, d);
      a.push(A(b));
      g = e = null;

      for (m in c) {
        if (p.call(c, m) && (h = c[m], null != h)) switch (m) {
          case "children":
            e = h;
            break;

          case "dangerouslySetInnerHTML":
            g = h;
            break;

          case "style":
            ta(a, d, h);
            break;

          case "suppressContentEditableWarning":
          case "suppressHydrationWarning":
            break;

          default:
            ja(m) && "function" !== typeof h && "symbol" !== _typeof(h) && a.push(" ", m, '="', v(h), '"');
        }
      }

      a.push(">");
      y(a, g, e);
      return e;
  }
}

function za(a, b, c) {
  a.push('\x3c!--$?--\x3e<template id="');
  if (null === c) throw Error(l(395));
  a.push(c);
  return a.push('"></template>');
}

function Aa(a, b, c, d) {
  switch (c.insertionMode) {
    case 0:
    case 1:
      return a.push('<div hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');

    case 2:
      return a.push('<svg aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');

    case 3:
      return a.push('<math aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');

    case 4:
      return a.push('<table hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');

    case 5:
      return a.push('<table hidden><tbody id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');

    case 6:
      return a.push('<table hidden><tr id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');

    case 7:
      return a.push('<table hidden><colgroup id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');

    default:
      throw Error(l(397));
  }
}

function Ba(a, b) {
  switch (b.insertionMode) {
    case 0:
    case 1:
      return a.push("</div>");

    case 2:
      return a.push("</svg>");

    case 3:
      return a.push("</math>");

    case 4:
      return a.push("</table>");

    case 5:
      return a.push("</tbody></table>");

    case 6:
      return a.push("</tr></table>");

    case 7:
      return a.push("</colgroup></table>");

    default:
      throw Error(l(397));
  }
}

var Ca = /[<\u2028\u2029]/g;

function Da(a) {
  return JSON.stringify(a).replace(Ca, function (a) {
    switch (a) {
      case "<":
        return "\\u003c";

      case "\u2028":
        return "\\u2028";

      case "\u2029":
        return "\\u2029";

      default:
        throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
    }
  });
}

function Ea(a, b) {
  b = void 0 === b ? "" : b;
  return {
    bootstrapChunks: [],
    startInlineScript: "<script>",
    placeholderPrefix: b + "P:",
    segmentPrefix: b + "S:",
    boundaryPrefix: b + "B:",
    idPrefix: b,
    nextSuspenseID: 0,
    sentCompleteSegmentFunction: !1,
    sentCompleteBoundaryFunction: !1,
    sentClientRenderFunction: !1,
    generateStaticMarkup: a
  };
}

function Fa(a, b, c, d) {
  if (c.generateStaticMarkup) return a.push(v(b)), !1;
  "" === b ? a = d : (d && a.push("\x3c!-- --\x3e"), a.push(v(b)), a = !0);
  return a;
}

var B = Object.assign,
    Ga = Symbol.for("react.element"),
    Ha = Symbol.for("react.portal"),
    Ia = Symbol.for("react.fragment"),
    Ja = Symbol.for("react.strict_mode"),
    Ka = Symbol.for("react.profiler"),
    La = Symbol.for("react.provider"),
    Ma = Symbol.for("react.context"),
    Na = Symbol.for("react.forward_ref"),
    Oa = Symbol.for("react.suspense"),
    Pa = Symbol.for("react.suspense_list"),
    Qa = Symbol.for("react.memo"),
    Ra = Symbol.for("react.lazy"),
    Sa = Symbol.for("react.scope"),
    Ta = Symbol.for("react.debug_trace_mode"),
    Ua = Symbol.for("react.legacy_hidden"),
    Va = Symbol.for("react.default_value"),
    Wa = Symbol.iterator;

function Xa(a) {
  if (null == a) return null;
  if ("function" === typeof a) return a.displayName || a.name || null;
  if ("string" === typeof a) return a;

  switch (a) {
    case Ia:
      return "Fragment";

    case Ha:
      return "Portal";

    case Ka:
      return "Profiler";

    case Ja:
      return "StrictMode";

    case Oa:
      return "Suspense";

    case Pa:
      return "SuspenseList";
  }

  if ("object" === _typeof(a)) switch (a.$$typeof) {
    case Ma:
      return (a.displayName || "Context") + ".Consumer";

    case La:
      return (a._context.displayName || "Context") + ".Provider";

    case Na:
      var b = a.render;
      a = a.displayName;
      a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
      return a;

    case Qa:
      return b = a.displayName || null, null !== b ? b : Xa(a.type) || "Memo";

    case Ra:
      b = a._payload;
      a = a._init;

      try {
        return Xa(a(b));
      } catch (c) {}

  }
  return null;
}

var Ya = {};

function Za(a, b) {
  a = a.contextTypes;
  if (!a) return Ya;
  var c = {},
      d;

  for (d in a) {
    c[d] = b[d];
  }

  return c;
}

var E = null;

function F(a, b) {
  if (a !== b) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    var c = b.parent;

    if (null === a) {
      if (null !== c) throw Error(l(401));
    } else {
      if (null === c) throw Error(l(401));
      F(a, c);
    }

    b.context._currentValue2 = b.value;
  }
}

function $a(a) {
  a.context._currentValue2 = a.parentValue;
  a = a.parent;
  null !== a && $a(a);
}

function ab(a) {
  var b = a.parent;
  null !== b && ab(b);
  a.context._currentValue2 = a.value;
}

function bb(a, b) {
  a.context._currentValue2 = a.parentValue;
  a = a.parent;
  if (null === a) throw Error(l(402));
  a.depth === b.depth ? F(a, b) : bb(a, b);
}

function cb(a, b) {
  var c = b.parent;
  if (null === c) throw Error(l(402));
  a.depth === c.depth ? F(a, c) : cb(a, c);
  b.context._currentValue2 = b.value;
}

function G(a) {
  var b = E;
  b !== a && (null === b ? ab(a) : null === a ? $a(b) : b.depth === a.depth ? F(b, a) : b.depth > a.depth ? bb(b, a) : cb(b, a), E = a);
}

var db = {
  isMounted: function isMounted() {
    return !1;
  },
  enqueueSetState: function enqueueSetState(a, b) {
    a = a._reactInternals;
    null !== a.queue && a.queue.push(b);
  },
  enqueueReplaceState: function enqueueReplaceState(a, b) {
    a = a._reactInternals;
    a.replace = !0;
    a.queue = [b];
  },
  enqueueForceUpdate: function enqueueForceUpdate() {}
};

function eb(a, b, c, d) {
  var f = void 0 !== a.state ? a.state : null;
  a.updater = db;
  a.props = c;
  a.state = f;
  var e = {
    queue: [],
    replace: !1
  };
  a._reactInternals = e;
  var g = b.contextType;
  a.context = "object" === _typeof(g) && null !== g ? g._currentValue2 : d;
  g = b.getDerivedStateFromProps;
  "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : B({}, f, g), a.state = f);
  if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && db.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
    if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];else {
      e = g ? b[0] : a.state;
      f = !0;

      for (g = g ? 1 : 0; g < b.length; g++) {
        var h = b[g];
        h = "function" === typeof h ? h.call(a, e, c, d) : h;
        null != h && (f ? (f = !1, e = B({}, e, h)) : B(e, h));
      }

      a.state = e;
    }
  } else e.queue = null;
}

var fb = {
  id: 1,
  overflow: ""
};

function gb(a, b, c) {
  var d = a.id;
  a = a.overflow;
  var f = 32 - H(d) - 1;
  d &= ~(1 << f);
  c += 1;
  var e = 32 - H(b) + f;

  if (30 < e) {
    var g = f - f % 5;
    e = (d & (1 << g) - 1).toString(32);
    d >>= g;
    f -= g;
    return {
      id: 1 << 32 - H(b) + f | c << f | d,
      overflow: e + a
    };
  }

  return {
    id: 1 << e | c << f | d,
    overflow: a
  };
}

var H = Math.clz32 ? Math.clz32 : hb,
    ib = Math.log,
    jb = Math.LN2;

function hb(a) {
  a >>>= 0;
  return 0 === a ? 32 : 31 - (ib(a) / jb | 0) | 0;
}

function kb(a, b) {
  return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}

var lb = "function" === typeof Object.is ? Object.is : kb,
    I = null,
    ob = null,
    J = null,
    K = null,
    L = !1,
    M = !1,
    N = 0,
    O = null,
    P = 0;

function Q() {
  if (null === I) throw Error(l(321));
  return I;
}

function pb() {
  if (0 < P) throw Error(l(312));
  return {
    memoizedState: null,
    queue: null,
    next: null
  };
}

function qb() {
  null === K ? null === J ? (L = !1, J = K = pb()) : (L = !0, K = J) : null === K.next ? (L = !1, K = K.next = pb()) : (L = !0, K = K.next);
  return K;
}

function rb() {
  ob = I = null;
  M = !1;
  J = null;
  P = 0;
  K = O = null;
}

function sb(a, b) {
  return "function" === typeof b ? b(a) : b;
}

function tb(a, b, c) {
  I = Q();
  K = qb();

  if (L) {
    var d = K.queue;
    b = d.dispatch;

    if (null !== O && (c = O.get(d), void 0 !== c)) {
      O.delete(d);
      d = K.memoizedState;

      do {
        d = a(d, c.action), c = c.next;
      } while (null !== c);

      K.memoizedState = d;
      return [d, b];
    }

    return [K.memoizedState, b];
  }

  a = a === sb ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
  K.memoizedState = a;
  a = K.queue = {
    last: null,
    dispatch: null
  };
  a = a.dispatch = ub.bind(null, I, a);
  return [K.memoizedState, a];
}

function vb(a, b) {
  I = Q();
  K = qb();
  b = void 0 === b ? null : b;

  if (null !== K) {
    var c = K.memoizedState;

    if (null !== c && null !== b) {
      var d = c[1];

      a: if (null === d) d = !1;else {
        for (var f = 0; f < d.length && f < b.length; f++) {
          if (!lb(b[f], d[f])) {
            d = !1;
            break a;
          }
        }

        d = !0;
      }

      if (d) return c[0];
    }
  }

  a = a();
  K.memoizedState = [a, b];
  return a;
}

function ub(a, b, c) {
  if (25 <= P) throw Error(l(301));
  if (a === I) if (M = !0, a = {
    action: c,
    next: null
  }, null === O && (O = new Map()), c = O.get(b), void 0 === c) O.set(b, a);else {
    for (b = c; null !== b.next;) {
      b = b.next;
    }

    b.next = a;
  }
}

function wb() {
  throw Error(l(394));
}

function R() {}

var xb = {
  readContext: function readContext(a) {
    return a._currentValue2;
  },
  useContext: function useContext(a) {
    Q();
    return a._currentValue2;
  },
  useMemo: vb,
  useReducer: tb,
  useRef: function useRef(a) {
    I = Q();
    K = qb();
    var b = K.memoizedState;
    return null === b ? (a = {
      current: a
    }, K.memoizedState = a) : b;
  },
  useState: function useState(a) {
    return tb(sb, a);
  },
  useInsertionEffect: R,
  useLayoutEffect: function useLayoutEffect() {},
  useCallback: function useCallback(a, b) {
    return vb(function () {
      return a;
    }, b);
  },
  useImperativeHandle: R,
  useEffect: R,
  useDebugValue: R,
  useDeferredValue: function useDeferredValue(a) {
    Q();
    return a;
  },
  useTransition: function useTransition() {
    Q();
    return [!1, wb];
  },
  useId: function useId() {
    var a = ob.treeContext;
    var b = a.overflow;
    a = a.id;
    a = (a & ~(1 << 32 - H(a) - 1)).toString(32) + b;
    var c = S;
    if (null === c) throw Error(l(404));
    b = N++;
    a = ":" + c.idPrefix + "R" + a;
    0 < b && (a += "H" + b.toString(32));
    return a + ":";
  },
  useMutableSource: function useMutableSource(a, b) {
    Q();
    return b(a._source);
  },
  useSyncExternalStore: function useSyncExternalStore(a, b, c) {
    if (void 0 === c) throw Error(l(407));
    return c();
  }
},
    S = null,
    yb = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;

function zb(a) {
  console.error(a);
  return null;
}

function T() {}

function Ab(a, b, c, d, f, e, g, h, k) {
  var m = [],
      n = new Set();
  b = {
    destination: null,
    responseState: b,
    progressiveChunkSize: void 0 === d ? 12800 : d,
    status: 0,
    fatalError: null,
    nextSegmentId: 0,
    allPendingTasks: 0,
    pendingRootTasks: 0,
    completedRootSegment: null,
    abortableTasks: n,
    pingedTasks: m,
    clientRenderedBoundaries: [],
    completedBoundaries: [],
    partialBoundaries: [],
    onError: void 0 === f ? zb : f,
    onAllReady: void 0 === e ? T : e,
    onShellReady: void 0 === g ? T : g,
    onShellError: void 0 === h ? T : h,
    onFatalError: void 0 === k ? T : k
  };
  c = U(b, 0, null, c, !1, !1);
  c.parentFlushed = !0;
  a = Bb(b, a, null, c, n, Ya, null, fb);
  m.push(a);
  return b;
}

function Bb(a, b, c, d, f, e, g, h) {
  a.allPendingTasks++;
  null === c ? a.pendingRootTasks++ : c.pendingTasks++;
  var k = {
    node: b,
    ping: function ping() {
      var b = a.pingedTasks;
      b.push(k);
      1 === b.length && Cb(a);
    },
    blockedBoundary: c,
    blockedSegment: d,
    abortSet: f,
    legacyContext: e,
    context: g,
    treeContext: h
  };
  f.add(k);
  return k;
}

function U(a, b, c, d, f, e) {
  return {
    status: 0,
    id: -1,
    index: b,
    parentFlushed: !1,
    chunks: [],
    children: [],
    formatContext: d,
    boundary: c,
    lastPushedText: f,
    textEmbedded: e
  };
}

function V(a, b) {
  a = a.onError(b);
  if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + _typeof(a) + '" instead');
  return a;
}

function W(a, b) {
  var c = a.onShellError;
  c(b);
  c = a.onFatalError;
  c(b);
  null !== a.destination ? (a.status = 2, a.destination.destroy(b)) : (a.status = 1, a.fatalError = b);
}

function Db(a, b, c, d, f) {
  I = {};
  ob = b;
  N = 0;

  for (a = c(d, f); M;) {
    M = !1, N = 0, P += 1, K = null, a = c(d, f);
  }

  rb();
  return a;
}

function Eb(a, b, c, d) {
  var f = c.render(),
      e = d.childContextTypes;

  if (null !== e && void 0 !== e) {
    var g = b.legacyContext;
    if ("function" !== typeof c.getChildContext) d = g;else {
      c = c.getChildContext();

      for (var h in c) {
        if (!(h in e)) throw Error(l(108, Xa(d) || "Unknown", h));
      }

      d = B({}, g, c);
    }
    b.legacyContext = d;
    X(a, b, f);
    b.legacyContext = g;
  } else X(a, b, f);
}

function Fb(a, b) {
  if (a && a.defaultProps) {
    b = B({}, b);
    a = a.defaultProps;

    for (var c in a) {
      void 0 === b[c] && (b[c] = a[c]);
    }

    return b;
  }

  return b;
}

function Gb(a, b, c, d, f) {
  if ("function" === typeof c) {
    if (c.prototype && c.prototype.isReactComponent) {
      f = Za(c, b.legacyContext);
      var e = c.contextType;
      e = new c(d, "object" === _typeof(e) && null !== e ? e._currentValue2 : f);
      eb(e, c, d, f);
      Eb(a, b, e, c);
    } else {
      e = Za(c, b.legacyContext);
      f = Db(a, b, c, d, e);
      var g = 0 !== N;
      if ("object" === _typeof(f) && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) eb(f, c, d, e), Eb(a, b, f, c);else if (g) {
        d = b.treeContext;
        b.treeContext = gb(d, 1, 0);

        try {
          X(a, b, f);
        } finally {
          b.treeContext = d;
        }
      } else X(a, b, f);
    }
  } else if ("string" === typeof c) {
    f = b.blockedSegment;
    e = ya(f.chunks, c, d, a.responseState, f.formatContext);
    f.lastPushedText = !1;
    g = f.formatContext;
    f.formatContext = ra(g, c, d);
    Hb(a, b, e);
    f.formatContext = g;

    switch (c) {
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "img":
      case "input":
      case "keygen":
      case "link":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
        break;

      default:
        f.chunks.push("</", c, ">");
    }

    f.lastPushedText = !1;
  } else {
    switch (c) {
      case Ua:
      case Ta:
      case Ja:
      case Ka:
      case Ia:
        X(a, b, d.children);
        return;

      case Pa:
        X(a, b, d.children);
        return;

      case Sa:
        throw Error(l(343));

      case Oa:
        a: {
          c = b.blockedBoundary;
          f = b.blockedSegment;
          e = d.fallback;
          d = d.children;
          g = new Set();
          var h = {
            id: null,
            rootSegmentID: -1,
            parentFlushed: !1,
            pendingTasks: 0,
            forceClientRender: !1,
            completedSegments: [],
            byteSize: 0,
            fallbackAbortableTasks: g,
            errorDigest: null
          },
              k = U(a, f.chunks.length, h, f.formatContext, !1, !1);
          f.children.push(k);
          f.lastPushedText = !1;
          var m = U(a, 0, null, f.formatContext, !1, !1);
          m.parentFlushed = !0;
          b.blockedBoundary = h;
          b.blockedSegment = m;

          try {
            if (Hb(a, b, d), a.responseState.generateStaticMarkup || m.lastPushedText && m.textEmbedded && m.chunks.push("\x3c!-- --\x3e"), m.status = 1, Y(h, m), 0 === h.pendingTasks) break a;
          } catch (n) {
            m.status = 4, h.forceClientRender = !0, h.errorDigest = V(a, n);
          } finally {
            b.blockedBoundary = c, b.blockedSegment = f;
          }

          b = Bb(a, e, c, k, g, b.legacyContext, b.context, b.treeContext);
          a.pingedTasks.push(b);
        }

        return;
    }

    if ("object" === _typeof(c) && null !== c) switch (c.$$typeof) {
      case Na:
        d = Db(a, b, c.render, d, f);

        if (0 !== N) {
          c = b.treeContext;
          b.treeContext = gb(c, 1, 0);

          try {
            X(a, b, d);
          } finally {
            b.treeContext = c;
          }
        } else X(a, b, d);

        return;

      case Qa:
        c = c.type;
        d = Fb(c, d);
        Gb(a, b, c, d, f);
        return;

      case La:
        f = d.children;
        c = c._context;
        d = d.value;
        e = c._currentValue2;
        c._currentValue2 = d;
        g = E;
        E = d = {
          parent: g,
          depth: null === g ? 0 : g.depth + 1,
          context: c,
          parentValue: e,
          value: d
        };
        b.context = d;
        X(a, b, f);
        a = E;
        if (null === a) throw Error(l(403));
        d = a.parentValue;
        a.context._currentValue2 = d === Va ? a.context._defaultValue : d;
        a = E = a.parent;
        b.context = a;
        return;

      case Ma:
        d = d.children;
        d = d(c._currentValue2);
        X(a, b, d);
        return;

      case Ra:
        f = c._init;
        c = f(c._payload);
        d = Fb(c, d);
        Gb(a, b, c, d, void 0);
        return;
    }
    throw Error(l(130, null == c ? c : _typeof(c), ""));
  }
}

function X(a, b, c) {
  b.node = c;

  if ("object" === _typeof(c) && null !== c) {
    switch (c.$$typeof) {
      case Ga:
        Gb(a, b, c.type, c.props, c.ref);
        return;

      case Ha:
        throw Error(l(257));

      case Ra:
        var d = c._init;
        c = d(c._payload);
        X(a, b, c);
        return;
    }

    if (qa(c)) {
      Ib(a, b, c);
      return;
    }

    null === c || "object" !== _typeof(c) ? d = null : (d = Wa && c[Wa] || c["@@iterator"], d = "function" === typeof d ? d : null);

    if (d && (d = d.call(c))) {
      c = d.next();

      if (!c.done) {
        var f = [];

        do {
          f.push(c.value), c = d.next();
        } while (!c.done);

        Ib(a, b, f);
      }

      return;
    }

    a = Object.prototype.toString.call(c);
    throw Error(l(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
  }

  "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = Fa(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = Fa(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}

function Ib(a, b, c) {
  for (var d = c.length, f = 0; f < d; f++) {
    var e = b.treeContext;
    b.treeContext = gb(e, d, f);

    try {
      Hb(a, b, c[f]);
    } finally {
      b.treeContext = e;
    }
  }
}

function Hb(a, b, c) {
  var d = b.blockedSegment.formatContext,
      f = b.legacyContext,
      e = b.context;

  try {
    return X(a, b, c);
  } catch (k) {
    if (rb(), "object" === _typeof(k) && null !== k && "function" === typeof k.then) {
      c = k;
      var g = b.blockedSegment,
          h = U(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
      g.children.push(h);
      g.lastPushedText = !1;
      a = Bb(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
      c.then(a, a);
      b.blockedSegment.formatContext = d;
      b.legacyContext = f;
      b.context = e;
      G(e);
    } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, G(e), k;
  }
}

function Jb(a) {
  var b = a.blockedBoundary;
  a = a.blockedSegment;
  a.status = 3;
  Kb(this, b, a);
}

function Lb(a, b, c) {
  var d = a.blockedBoundary;
  a.blockedSegment.status = 3;
  null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.push(null))) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error(l(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function (a) {
    return Lb(a, b, c);
  }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}

function Y(a, b) {
  if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
    var c = b.children[0];
    c.id = b.id;
    c.parentFlushed = !0;
    1 === c.status && Y(a, c);
  } else a.completedSegments.push(b);
}

function Kb(a, b, c) {
  if (null === b) {
    if (c.parentFlushed) {
      if (null !== a.completedRootSegment) throw Error(l(389));
      a.completedRootSegment = c;
    }

    a.pendingRootTasks--;
    0 === a.pendingRootTasks && (a.onShellError = T, b = a.onShellReady, b());
  } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && Y(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach(Jb, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && (Y(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));

  a.allPendingTasks--;
  0 === a.allPendingTasks && (a = a.onAllReady, a());
}

function Cb(a) {
  if (2 !== a.status) {
    var b = E,
        c = yb.current;
    yb.current = xb;
    var d = S;
    S = a.responseState;

    try {
      var f = a.pingedTasks,
          e;

      for (e = 0; e < f.length; e++) {
        var g = f[e];
        var h = a,
            k = g.blockedSegment;

        if (0 === k.status) {
          G(g.context);

          try {
            X(h, g, g.node), h.responseState.generateStaticMarkup || k.lastPushedText && k.textEmbedded && k.chunks.push("\x3c!-- --\x3e"), g.abortSet.delete(g), k.status = 1, Kb(h, g.blockedBoundary, k);
          } catch (z) {
            if (rb(), "object" === _typeof(z) && null !== z && "function" === typeof z.then) {
              var m = g.ping;
              z.then(m, m);
            } else {
              g.abortSet.delete(g);
              k.status = 4;
              var n = g.blockedBoundary,
                  q = z,
                  C = V(h, q);
              null === n ? W(h, q) : (n.pendingTasks--, n.forceClientRender || (n.forceClientRender = !0, n.errorDigest = C, n.parentFlushed && h.clientRenderedBoundaries.push(n)));
              h.allPendingTasks--;

              if (0 === h.allPendingTasks) {
                var D = h.onAllReady;
                D();
              }
            }
          } finally {}
        }
      }

      f.splice(0, e);
      null !== a.destination && Mb(a, a.destination);
    } catch (z) {
      V(a, z), W(a, z);
    } finally {
      S = d, yb.current = c, c === xb && G(b);
    }
  }
}

function Z(a, b, c) {
  c.parentFlushed = !0;

  switch (c.status) {
    case 0:
      var d = c.id = a.nextSegmentId++;
      c.lastPushedText = !1;
      c.textEmbedded = !1;
      a = a.responseState;
      b.push('<template id="');
      b.push(a.placeholderPrefix);
      a = d.toString(16);
      b.push(a);
      return b.push('"></template>');

    case 1:
      c.status = 2;
      var f = !0;
      d = c.chunks;
      var e = 0;
      c = c.children;

      for (var g = 0; g < c.length; g++) {
        for (f = c[g]; e < f.index; e++) {
          b.push(d[e]);
        }

        f = Nb(a, b, f);
      }

      for (; e < d.length - 1; e++) {
        b.push(d[e]);
      }

      e < d.length && (f = b.push(d[e]));
      return f;

    default:
      throw Error(l(390));
  }
}

function Nb(a, b, c) {
  var d = c.boundary;
  if (null === d) return Z(a, b, c);
  d.parentFlushed = !0;
  if (d.forceClientRender) return a.responseState.generateStaticMarkup || (d = d.errorDigest, b.push("\x3c!--$!--\x3e"), b.push("<template"), d && (b.push(' data-dgst="'), d = v(d), b.push(d), b.push('"')), b.push("></template>")), Z(a, b, c), a = a.responseState.generateStaticMarkup ? !0 : b.push("\x3c!--/$--\x3e"), a;

  if (0 < d.pendingTasks) {
    d.rootSegmentID = a.nextSegmentId++;
    0 < d.completedSegments.length && a.partialBoundaries.push(d);
    var f = a.responseState;
    var e = f.nextSuspenseID++;
    f = f.boundaryPrefix + e.toString(16);
    d = d.id = f;
    za(b, a.responseState, d);
    Z(a, b, c);
    return b.push("\x3c!--/$--\x3e");
  }

  if (d.byteSize > a.progressiveChunkSize) return d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), za(b, a.responseState, d.id), Z(a, b, c), b.push("\x3c!--/$--\x3e");
  a.responseState.generateStaticMarkup || b.push("\x3c!--$--\x3e");
  c = d.completedSegments;
  if (1 !== c.length) throw Error(l(391));
  Nb(a, b, c[0]);
  a = a.responseState.generateStaticMarkup ? !0 : b.push("\x3c!--/$--\x3e");
  return a;
}

function Ob(a, b, c) {
  Aa(b, a.responseState, c.formatContext, c.id);
  Nb(a, b, c);
  return Ba(b, c.formatContext);
}

function Pb(a, b, c) {
  for (var d = c.completedSegments, f = 0; f < d.length; f++) {
    Qb(a, b, c, d[f]);
  }

  d.length = 0;
  a = a.responseState;
  d = c.id;
  c = c.rootSegmentID;
  b.push(a.startInlineScript);
  a.sentCompleteBoundaryFunction ? b.push('$RC("') : (a.sentCompleteBoundaryFunction = !0, b.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'));
  if (null === d) throw Error(l(395));
  c = c.toString(16);
  b.push(d);
  b.push('","');
  b.push(a.segmentPrefix);
  b.push(c);
  return b.push('")\x3c/script>');
}

function Qb(a, b, c, d) {
  if (2 === d.status) return !0;
  var f = d.id;

  if (-1 === f) {
    if (-1 === (d.id = c.rootSegmentID)) throw Error(l(392));
    return Ob(a, b, d);
  }

  Ob(a, b, d);
  a = a.responseState;
  b.push(a.startInlineScript);
  a.sentCompleteSegmentFunction ? b.push('$RS("') : (a.sentCompleteSegmentFunction = !0, b.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'));
  b.push(a.segmentPrefix);
  f = f.toString(16);
  b.push(f);
  b.push('","');
  b.push(a.placeholderPrefix);
  b.push(f);
  return b.push('")\x3c/script>');
}

function Mb(a, b) {
  try {
    var c = a.completedRootSegment;

    if (null !== c && 0 === a.pendingRootTasks) {
      Nb(a, b, c);
      a.completedRootSegment = null;
      var d = a.responseState.bootstrapChunks;

      for (c = 0; c < d.length - 1; c++) {
        b.push(d[c]);
      }

      c < d.length && b.push(d[c]);
    }

    var f = a.clientRenderedBoundaries,
        e;

    for (e = 0; e < f.length; e++) {
      var g = f[e];
      d = b;
      var h = a.responseState,
          k = g.id,
          m = g.errorDigest,
          n = g.errorMessage,
          q = g.errorComponentStack;
      d.push(h.startInlineScript);
      h.sentClientRenderFunction ? d.push('$RX("') : (h.sentClientRenderFunction = !0, d.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'));
      if (null === k) throw Error(l(395));
      d.push(k);
      d.push('"');

      if (m || n || q) {
        d.push(",");
        var C = Da(m || "");
        d.push(C);
      }

      if (n || q) {
        d.push(",");
        var D = Da(n || "");
        d.push(D);
      }

      if (q) {
        d.push(",");
        var z = Da(q);
        d.push(z);
      }

      if (!d.push(")\x3c/script>")) {
        a.destination = null;
        e++;
        f.splice(0, e);
        return;
      }
    }

    f.splice(0, e);
    var ba = a.completedBoundaries;

    for (e = 0; e < ba.length; e++) {
      if (!Pb(a, b, ba[e])) {
        a.destination = null;
        e++;
        ba.splice(0, e);
        return;
      }
    }

    ba.splice(0, e);
    var ca = a.partialBoundaries;

    for (e = 0; e < ca.length; e++) {
      var mb = ca[e];

      a: {
        f = a;
        g = b;
        var da = mb.completedSegments;

        for (h = 0; h < da.length; h++) {
          if (!Qb(f, g, mb, da[h])) {
            h++;
            da.splice(0, h);
            var nb = !1;
            break a;
          }
        }

        da.splice(0, h);
        nb = !0;
      }

      if (!nb) {
        a.destination = null;
        e++;
        ca.splice(0, e);
        return;
      }
    }

    ca.splice(0, e);
    var ea = a.completedBoundaries;

    for (e = 0; e < ea.length; e++) {
      if (!Pb(a, b, ea[e])) {
        a.destination = null;
        e++;
        ea.splice(0, e);
        return;
      }
    }

    ea.splice(0, e);
  } finally {
    0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.push(null);
  }
}

function Rb(a, b) {
  try {
    var c = a.abortableTasks;
    c.forEach(function (c) {
      return Lb(c, a, b);
    });
    c.clear();
    null !== a.destination && Mb(a, a.destination);
  } catch (d) {
    V(a, d), W(a, d);
  }
}

function Sb() {}

function Tb(a, b, c, d) {
  var f = !1,
      e = null,
      g = "",
      h = {
    push: function push(a) {
      null !== a && (g += a);
      return !0;
    },
    destroy: function destroy(a) {
      f = !0;
      e = a;
    }
  },
      k = !1;
  a = Ab(a, Ea(c, b ? b.identifierPrefix : void 0), {
    insertionMode: 1,
    selectedValue: null
  }, Infinity, Sb, void 0, function () {
    k = !0;
  }, void 0, void 0);
  Cb(a);
  Rb(a, d);
  if (1 === a.status) a.status = 2, h.destroy(a.fatalError);else if (2 !== a.status && null === a.destination) {
    a.destination = h;

    try {
      Mb(a, h);
    } catch (m) {
      V(a, m), W(a, m);
    }
  }
  if (f) throw e;
  if (!k) throw Error(l(426));
  return g;
}

exports.renderToNodeStream = function () {
  throw Error(l(207));
};

exports.renderToStaticMarkup = function (a, b) {
  return Tb(a, b, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};

exports.renderToStaticNodeStream = function () {
  throw Error(l(208));
};

exports.renderToString = function (a, b) {
  return Tb(a, b, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};

exports.version = "18.2.0";